import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@bcmi-labs/react-components';

import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { EffectFade, Pagination, Autoplay, Navigation } from 'swiper';
import { IconUserProfileOutline } from '@bcmi-labs/icons';

// Styles must use direct files imports
import 'swiper/swiper.scss'; // core Swiper
import 'swiper/modules/pagination/pagination.scss'; // Pagination module
import 'swiper/modules/effect-fade/effect-fade.scss'; // Pagination module

import './LoginSelector.scss';

const LoginSelector = (props) => {
  const { t } = useTranslation('login');
  //  Show footer after first render
  useEffect(() => {
    document.getElementById('footer').style.display = 'block';
  }, []);

  return (
    <div className="login-selector-layout">
      <main className="login-selector">
        <section>
          <h1 className="arduino-typography-large-strong">{t('login:welcomeTitle')}</h1>
          <p>{t('login:welcomeSubTitle')}</p>
          <Button className="login-button" type={'button'} onClick={() => props.onViewSelection('adult-login')}>
            <IconUserProfileOutline />
            {t('login:signIn')}
          </Button>

          <span className="register-text">
            {t('login:noAccount')}{' '}
            <Link className="register-link" to="/register">
              {t('login:createAccount')}
            </Link>
          </span>
        </section>

        <button className="kid-login-card" aria-label="kid login" onClick={() => props.onViewSelection('kid-login')}>
          <div>
            <span>{t('login:juniorBannerTitle')}</span>
            <span>{t('login:juniorBannerSubtitle')}</span>
          </div>
          <div className="kid-image-wrapper"></div>
        </button>
      </main>
      <aside>
        <Swiper
          spaceBetween={0}
          grabCursor={false}
          watchOverflow={false}
          direction={'horizontal'}
          allowTouchMove={false}
          loop={true}
          autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
          modules={[EffectFade, Navigation, Pagination, Autoplay]}
          effect="fade"
          className="swiper"
          pagination={{
            clickable: true,
            el: '.swiper-pagination-ph',
          }}
        >
          <SwiperSlide>
            <div className="slide dashboard">
              <div className="slide-image-wrapper"></div>
              <h2>{t('login:carousel:dashboard:title')}</h2>
              <p>{t('login:carousel:dashboard:subTitle')}</p>
              <div className="swiper-pagination-wrapper">
                <div className="swiper-pagination swiper-pagination-ph"></div>
              </div>
              <a href="https://www.arduino.cc/cloud/" target="_blank" rel="noopener noreferrer">
                {t('login:carousel:discover')}
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="slide device">
              <div className="slide-image-wrapper"></div>
              <h2>{t('login:carousel:device:title')}</h2>
              <p>{t('login:carousel:device:subTitle')}</p>
              <div className="swiper-pagination-wrapper">
                <div className="swiper-pagination swiper-pagination-ph"></div>
              </div>
              <a href="https://www.arduino.cc/cloud/" target="_blank" rel="noopener noreferrer">
                {t('login:carousel:discover')}
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="slide project">
              <div className="slide-image-wrapper"></div>
              <h2>{t('login:carousel:project:title')}</h2>
              <p>{t('login:carousel:project:subTitle')}</p>
              <div className="swiper-pagination-wrapper">
                <div className="swiper-pagination swiper-pagination-ph"></div>
              </div>
              <a href="https://www.arduino.cc/cloud/" target="_blank" rel="noopener noreferrer">
                {t('login:carousel:discover')}
              </a>
            </div>
          </SwiperSlide>
        </Swiper>
      </aside>
    </div>
  );
};

LoginSelector.propTypes = {
  onViewSelection: PropTypes.func.isRequired,
};

export default LoginSelector;
